import { render, staticRenderFns } from "./SimulationExamPage.vue?vue&type=template&id=058b2372&scoped=true&"
import script from "./SimulationExamPage.vue?vue&type=script&lang=js&"
export * from "./SimulationExamPage.vue?vue&type=script&lang=js&"
import style0 from "./SimulationExamPage.vue?vue&type=style&index=0&id=058b2372&prod&scoped=true&lang=scss&"
import style1 from "./SimulationExamPage.vue?vue&type=style&index=1&id=058b2372&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058b2372",
  null
  
)

export default component.exports